export function normalizeTabSlug(value) {
  const s = typeof value === 'string' ? value : String(value ?? '');
  const withoutAccents = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const cleaned = withoutAccents
    .replace(/[^a-zA-Z0-9\s-]/g, '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
  return cleaned || 'tab';
}

const STUDENT_TAB_SLUG_ALIASES = {
  test: 'test-temas',
  tests: 'test-temas',
  'test-tema': 'test-temas',
  'test-temas': 'test-temas',
  'test-examen': 'test-examen',
  testexamen: 'test-examen',
  temas: 'campus',
  tema: 'campus',
  temario: 'campus',
  simulacro: 'test-temas',
  simulacros: 'test-temas',
  mensajes: 'mensajeria-interna',
  mensaje: 'mensajeria-interna',
  mensajeria: 'mensajeria-interna',
  'mensajeria-interna': 'mensajeria-interna',
  campus: 'campus',
  resumenes: 'resumenes',
  resumen: 'resumenes',
  rendimiento: 'rendimiento',
  informacion: 'informacion',
};

/** Maps course tab labels to registered /usuario/* route segments. */
export function resolveStudentTabRouteSlug(tabLabel) {
  const slug = normalizeTabSlug(tabLabel);
  return STUDENT_TAB_SLUG_ALIASES[slug] ?? slug;
}